// ---------------------------
// AUTO-GENERATED. DO NOT EAT.
// ---------------------------
import { createEnum } from "@cartographerio/util";
const None = "none";
const BedOnly = "bed";
const OneBankOnly = "oneBank";
const BedAndOneBankOnly = "bedOneBank";
const BothBanksOnly = "twoBanks";
const Full = "full";
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const UrsReinforcementLevelEnum = {
    ...createEnum("UrsReinforcementLevel", [
        [None, "None"],
        [BedOnly, "Bed only"],
        [OneBankOnly, "One bank only"],
        [BedAndOneBankOnly, "Bed and one bank only"],
        [BothBanksOnly, "Both banks only"],
        [Full, "Full"],
    ]),
    None,
    BedOnly,
    OneBankOnly,
    BedAndOneBankOnly,
    BothBanksOnly,
    Full,
};
null;
null;
export default UrsReinforcementLevelEnum;
//# sourceMappingURL=UrsReinforcementLevelEnum.generated.js.map